export default "skymp5-front/ccdc0aef3fd8c31deba576b47df0aa91.png";